<template>
	<Modal v-if="loaded" @close="$emit('close')">
		<template slot="title">AR SMS</template>
		<template slot="body">
			<table class="view_tbl" border="0" style="width: 600px;">
				<colgroup>
					<col style="width:80px;" />
					<col style="width:500px;" />
				</colgroup>
				<tbody>
					<tr>
						<th>Tel. SMS</th>
						<td>
							<input type="text" v-model.trim="sms_rcpt_number" class="tbl_int" />
						</td>
					</tr>
					<tr>
						<th></th>
						<td>
							<span style="color: red;"> SMS is sent within the US only,<br />Please be sure to exclude the international code (+1) from this phone number. </span>
						</td>
					</tr>
					<tr>
						<th>Content</th>
						<td>
							<div class="mc_textarea">
								<label>
									<textarea rows="12" name="content" v-model.trim="sms_body"></textarea>
								</label>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="popup_bottom">
				<a href="javascript:void(0);" @click="send" class="search_bt mgr_15">Send</a>
				<a href="javascript:void(0);" @click="$emit('close')" class="gray_bt">Close</a>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
import { apiGetArSmsBody, apiSendArSms } from '@/api/receipt/index.js';
import { apiSelectPartner } from '@/api/partner';

export default {
	name: 'ArSmsModal',
	components: {
		Modal,
	},
	props: {
		invoice_no: {
			type: String,
			default: '',
		},
		bill_to_code: {
			type: String,
			default: '',
		},
	},
	data: function() {
		return {
			loaded: false,
			sms_body: null,
			sms_rcpt_number: null,
		};
	},
	methods: {
		async send() {
			if (!this.sms_rcpt_number) {
				this.$toast.error('Empty Telephone Number.');
				return;
			}
			if (!this.sms_body) {
				this.$toast.error('Empty Content.');
				return;
			}

			const { data } = await apiSendArSms(this.invoice_no, this.bill_to_code, this.sms_rcpt_number, this.sms_body);
			if (data.result) {
				this.$toast.success('Success to Send SMS.');
				this.$emit('sent');
			} else {
				this.$toast.error(data.msg);
			}
		},
	},
	async created() {
		const sms_response = await apiGetArSmsBody(this.invoice_no);
		const cust_response = await apiSelectPartner({ code: this.bill_to_code });

		this.sms_body = sms_response.data;
		this.sms_rcpt_number = cust_response.data && cust_response.data.partner ? cust_response.data.partner.telephone_sms : null;
		this.loaded = true;
	},
};
</script>
